import { useEffect, useState } from "react";
import { api } from "@/lib/api";

let _cache = null;
let _fetchedAt = 0;
const TTL_MS = 60 * 60 * 1000; // 1h
const listeners = new Set();

export function invalidateCompanyInfo() {
  _cache = null;
  _fetchedAt = 0;
  listeners.forEach((fn) => fn(null));
}

export function cmsWizardText(company, step, field, lang, fallback) {
  const val = company?.wizard_texts?.[step]?.[field]?.[lang];
  return (typeof val === "string" && val.trim()) ? val : fallback;
}

export function useCompanyInfo() {
  const [data, setData] = useState(_cache);
  useEffect(() => {
    listeners.add(setData);
    const now = Date.now();
    if (_cache && now - _fetchedAt < TTL_MS) {
      setData(_cache);
      return () => listeners.delete(setData);
    }
    let cancelled = false;
    api.get("/company-info").then(({ data: d }) => {
      if (cancelled) return;
      _cache = d;
      _fetchedAt = Date.now();
      listeners.forEach((fn) => fn(d));
    }).catch(() => { /* silent — footer has sensible defaults */ });
    return () => { cancelled = true; listeners.delete(setData); };
  }, []);
  return data;
}
